
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Charts from "../SummaryTab/Charts";
import Filtering from "../RuleCatalogue/Filtering";
import PivotTable from "../SummaryTab/PivotTable";
import heartLoading from "../../assests/heartLoading.gif";
import preloader from "../../assests/preloader1.gif";

const Summary = ({
  productId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState(
    {
      "tableData": [
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_as_of_dt_is_in_list",
              "total_row_count": 39154,
              "error_record_count": 394,
              "validity": 98.99,
              "accuracy": null,
              "consistency": null,
              "completeness": null,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are in the allowed list."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_charg_is_not_null_and_not_empty",
              "total_row_count": 39154,
              "error_record_count": 19792,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 49.45,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null and not empty."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_di_operation_type_is_in_list",
              "total_row_count": 39154,
              "error_record_count": 0,
              "validity": 100.0,
              "accuracy": null,
              "consistency": null,
              "completeness": null,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are in the allowed list."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_di_operation_type_is_not_null",
              "total_row_count": 39154,
              "error_record_count": 0,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 100.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_di_sequence_number_is_not_null",
              "total_row_count": 39154,
              "error_record_count": 0,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 100.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_effective_dt_is_not_null",
              "total_row_count": 39154,
              "error_record_count": 0,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 100.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_ersda_is_not_null",
              "total_row_count": 39154,
              "error_record_count": 0,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 100.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_fsh_collection_is_not_null_and_not_empty",
              "total_row_count": 39154,
              "error_record_count": 39154,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 0.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null and not empty."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_fsh_salloc_qty_is_not_null",
              "total_row_count": 39154,
              "error_record_count": 0,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 100.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null."
          },
          {
              "rule_name": "mw_supply_raw_aep_sap|sap_msku_special_stock_customers_fsh_theme_is_not_null_and_not_empty",
              "total_row_count": 39154,
              "error_record_count": 39154,
              "validity": null,
              "accuracy": null,
              "consistency": null,
              "completeness": 0.0,
              "freshness": null,
              "uniqueness": null,
              "rule_description": "Checks whether the values are not null and not empty."
          }
      ],
      "dqMetrics": {
          "completeness": 76.62,
          "uniqueness": 4.0,
          "consistency": 0.0,
          "validity": 93.06,
          "accuracy": 0.0,
          "freshness": 0.02,
          "Overall DQ Score": 37.22
      },
      "filters": {
          "name": [],
          "list": {},
          "rulePhase": [
              "Post - Refresh",
              "Pre - Refresh"
          ]
      },
      "pagination": {
          "currentPage": 1,
          "pageSize": 10,
          "totalPages": 10,
          "totalRecords": 93
      }
  }
  ); // For product-overview (POST)
  const [loading, setLoading] = useState(false);
  const [dqScores, setDqScores] = useState({
    "completeness": 64.75,
    "uniqueness": 0.0,
    "consistency": 0.0,
    "validity": 63.18,
    "accuracy": 11.33,
    "freshness": 66.67,
    "Overall DQ Score": 33.39
}); // For charts (GET responses, raw)
const [activePeriod, setActivePeriod] = useState("Current");
  const initialLoaded = useRef(false);
  const [pivotGrouping, setPivotGrouping] = useState({});

  useEffect(() => {
  if (Object.keys(pivotGrouping).length > 0) {
    onFiltersChange({ pivot_grouping: pivotGrouping });
  }
}, [pivotGrouping, onFiltersChange]);

  // 👉 POST /product-overview (keep as is)
//   useEffect(() => {
//     if (!productId) return;

//     const payload = {
//       productId,
//       filters: currentFilters,
//       searchTerm,
//       page,
//       pageSize,
// period: activePeriod,    };
//     setLoading(true);

//     axios
//       .post(`${BASE_URL}/product-overview`, payload)
//       .then((res) => {
//         setData(res.data);
//          setDqScores(res.data.dqMetrics);
//         // setActivePeriod("");
//         initialLoaded.current = true;
//         setLoading(false);
//       })
//       .catch((err) => {
//         setLoading(false);
//         console.error("Error fetching product-overview:", err);
//       });
//   }, [productId, currentFilters, searchTerm, page, pageSize,activePeriod, BASE_URL]);



 

const handlePeriodChange = (period) => {
  if (period === "current") setActivePeriod("Current");
  else if (period === "last") setActivePeriod("Previous");
  else setActivePeriod("Current");
};
  // Handle pagination changes from PivotTable
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(1); // Reset to first page when page size changes
  };

  if (!data || (!dqScores && !data?.dqMetrics))
    return (
          <div className="relative bg-white flex items-center justify-center z-50 min-h-screen">
      <div className="flex flex-col items-center space-y-3">
        <img src={preloader} alt="Loading..." width={200} />
        <span className="text-gray-700 text-[20px] text-center">
          Hang tight! The resources are loading...
        </span>
      </div>
    </div>
    );

 

  const scoresForCharts = dqScores;


  return (
    <div className="summary">
      <Filtering
        availableFilters={data.filters}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
        showPeriodToggle={true}
        activePeriod={activePeriod}
        onPeriodChange={handlePeriodChange}
        onResetPeriod={() => setActivePeriod("")}
      />

      {/* <ChartsLine /> */}

      {scoresForCharts && <Charts scores={scoresForCharts} period={activePeriod ? activePeriod : ""} />}

      <PivotTable
        tableData={data.tableData}
        paginationData={data.pagination}
        filterList={data.filters.name}
        apiLoading={loading}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        onGroupingChange={setPivotGrouping}
        productId={productId}
        currentFilters={currentFilters}
        page={page}
        searchTerm={searchTerm}
      />
    </div>
  );
};

export default Summary;
